import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.text)?_c(VTooltip,{attrs:{"right":"","max-width":"20em"},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c(VIcon,_vm._g(_vm._b({staticClass:"icon"},'v-icon',attrs,false),on),[_vm._v("mdi-information-outline")])]}}],null,false,1762519348)},[_vm._v("\n  "+_vm._s(_vm.text)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }